// API base URL configuration
export const API_BASE_URL = (() => {
  if (typeof window === 'undefined') return '';
  
  if (window.location.hostname === 'localhost') {
    return 'http://localhost:5000';
  }
  
  // Check if we're on Vercel deployment
  const isVercel = window.location.hostname.includes('vercel.app') || 
                   window.location.hostname.includes('openorg.fyi');
                   
  if (isVercel) {
    // For Vercel, use the origin
    return window.location.origin;
  }
  
  // Default fallback
  return window.location.origin;
})(); 